import { Card, MainTitle, SubTitle, Divider, List } from '@repo/ui';
import { format } from 'date-fns';

import { RefundItemModel } from '@/components/my/refund-history/providers/RefundItemContext';
import numberWithCommas from '@/lib/utils/numberWithCommas';

interface RefundHistoryCardProps {
  item: RefundItemModel;
}

export const RefundHistoryCard = ({ item }: RefundHistoryCardProps) => {
  const addHyphenForVoucher = (bizNo: string) => {
    if (bizNo.includes('-')) {
      return bizNo;
    }

    // 사업자 등록번호
    if (bizNo.length === 10) {
      return bizNo.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    }

    // 주민등록번호
    return `${bizNo.substring(0, 6)}-${bizNo.substring(6, 7)}******`;
  };

  return (
    <Card outline={false} className="w-full !px-normal-large !py-0">
      <div className="py-normal-large">
        {/* TODO: 양도소득세 추가 - API 작업되면 진행할 예정입니다! (7/18 이후..)  */}
        <SubTitle title={`${item.corpType === 'CORPS' ? '법인세' : '종합소득세'} · ${item.bizName}`} size="small" className="!p-0 mx-normal-sma" />
        <MainTitle title={`${numberWithCommas(Number(item.refundAmount))}원`} size="medium" className="!p-0" />
      </div>
      <Divider />
      <div className="py-normal-small">
        {item.corpType === 'CORPS' && item.bizNo && (
          <List className="!py-normal-small" title="사업자등록번호" size="small" supportingElement={<div>{addHyphenForVoucher(item.bizNo)}</div>} />
        )}
        <List
          className="!py-normal-small"
          title="환급 신청일"
          size="small"
          supportingElement={<div>{format(new Date(item.applicationDt), 'yyyy년 M월 d일')}</div>}
        />
        {item.refundResultDt && (
          <List
            className="!py-normal-small"
            title="환급 결정일"
            size="small"
            supportingElement={<div>{format(new Date(item.refundResultDt), 'yyyy년 M월 d일')}</div>}
          />
        )}
        <List
          className="!py-normal-small"
          title="환급 계좌"
          size="small"
          supportingElement={
            <div>
              {item.bank.replace('은행', '')} {item.accountNo}
            </div>
          }
        />
        {item.paymentDt && (
          <List
            className="!py-normal-small"
            title="결제 완료일"
            size="small"
            supportingElement={<div>format(new Date(item.paymentDt), 'yyyy년 M월 d일')</div>}
          />
        )}
        <List className="!py-normal-small" title="결제 금액" size="small" supportingElement={<div>{numberWithCommas(item.paymentAmount)}원</div>} />
      </div>
    </Card>
  );
};
